// 💾 src/pages/admin/components/sections/DashboardPanel.tsx
import { useEffect, useState } from "react"
import { collection, collectionGroup, getDocs } from "firebase/firestore"
import { db } from "../../../../services/firebase"
import AdminAddTradeForm from "../AdminAddTradeForm"
import "../style/Dashboard.scss"

const DashboardPanel = () => {
  const [stats, setStats] = useState({
    users: 0,
    trades: 0,
    deposits: { count: 0, total: 0 },
    withdrawals: { count: 0, total: 0 }
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const usersSnap = await getDocs(collection(db, "users"))
        const tradesSnap = await getDocs(collectionGroup(db, "trades"))
        const depositsSnap = await getDocs(collectionGroup(db, "deposits"))
        let depositsTotal = 0
        depositsSnap.forEach((doc) => (depositsTotal += Number(doc.data().amount || 0)))

        const withdrawalsSnap = await getDocs(collectionGroup(db, "withdrawals"))
        let withdrawalsTotal = 0
        withdrawalsSnap.forEach((doc) => (withdrawalsTotal += Number(doc.data().amount || 0)))

        setStats({
          users: usersSnap.size,
          trades: tradesSnap.size,
          deposits: { count: depositsSnap.size, total: depositsTotal },
          withdrawals: { count: withdrawalsSnap.size, total: withdrawalsTotal }
        })
      } catch (err) {
        console.error("❌ Failed to fetch dashboard stats:", err)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [])

  if (loading) return <div className="admin-panel">Loading dashboard...</div>

  return (
    <div className="admin-panel dashboard-overview">
      <h2>📊 Dashboard Overview</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{stats.users}</h3>
          <p>Total Users</p>
        </div>
        <div className="stat-card">
          <h3>{stats.trades}</h3>
          <p>Total Trades</p>
        </div>
        <div className="stat-card">
          <h3>{stats.deposits.count}</h3>
          <p>Deposits (${stats.deposits.total})</p>
        </div>
        <div className="stat-card">
          <h3>{stats.withdrawals.count}</h3>
          <p>Withdrawals (${stats.withdrawals.total})</p>
        </div>
      </div>

      {/* 🔥 Add trade form here */}
      <div className="add-trade-section">
        <AdminAddTradeForm />
      </div>
    </div>
  )
}

export default DashboardPanel
